












































import Vue from "vue";

export default Vue.extend({
  name: "NumberTable",
  props: {
    validNumbers: {
      type: Array,
      default: () => ([])
    },
    invalidNumbers: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      height: 100
    }
  },
  computed: {
    isSorted() {
      return (num: number) => {
        return this.$store.state.sorted.includes(num)
      }
    },
    isValid() {
      return (num: number) => {
        return this.validNumbers.includes(num)
      }
    },
    isInvalid() {
      return (num: number) => {
        return this.invalidNumbers.includes(num)
      }
    },
    lastSorted() {
      return (num: number) => {
        return this.$store.state.sorted.length && this.$store.state.sorted.indexOf(num) === this.$store.state.sorted.length - 1
      }
    }
  },
  methods: {
    range(start: number, end: number) {
      return Array.from(Array(end + 1)).map((el, idx) => idx).slice(start, end + 1);
    }
  }
})
